import { ProgramContent } from '@cibo/core'
import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'

export const Qualifications = ({ program }: { program: { fields: ProgramContent } }) => {
  if (program.fields.qualifications === undefined) return null

  const {
    qualifications: { qualifications },
  } = program.fields

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={4}
      divider={<Divider orientation="vertical" flexItem />}
    >
      {qualifications.map(({ title, items }, index) => (
        <Stack sx={{ flex: 1 }} key={index}>
          <Typography variant="h5" align="left" color="text.secondary">
            {title}
          </Typography>
          <List>
            {items.map((qual, qualIndex) => (
              <ListItem key={qualIndex} color="text.secondary" alignItems="flex-start">
                <ListItemIcon sx={{ minWidth: 20, marginTop: '4px' }}>•</ListItemIcon>
                <ListItemText primary={qual} />
              </ListItem>
            ))}
          </List>
        </Stack>
      ))}
    </Stack>
  )
}
